// The Apsio mark (docs/brand.md, Mark): the uneven ring, the focus and the periapsis point.
export function Mark() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <g transform="rotate(-22 16 16)">
        <path
          d="M16 5a15 11 0 1 0 0 22a15 11 0 1 0 0-22zM14.4 7.6a12.2 8.4 0 1 0 0 16.8a12.2 8.4 0 1 0 0-16.8z"
          fill="currentColor"
          fillRule="evenodd"
        />
        <circle cx="22.4" cy="16" r="3" fill="currentColor" />
        <circle className="mark-peri" cx="28.8" cy="16" r="2.3" />
      </g>
    </svg>
  )
}
